import { render } from "./BomHeaderQuantity.vue?vue&type=template&id=3388b9ea&scoped=true"
import script from "./BomHeaderQuantity.vue?vue&type=script&lang=js"
export * from "./BomHeaderQuantity.vue?vue&type=script&lang=js"

import "./BomHeaderQuantity.vue?vue&type=style&index=0&id=3388b9ea&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3388b9ea"]])

export default __exports__